import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export const useUIStore = create(
  devtools(
    set => ({
      // Sidebar & Navigation
      isSidebarOpen: false,
      activeSection: null,

      // Modals
      isSettingsModalOpen: false,
      isFeedbackModalOpen: false,
      isUserMenuOpen: false,
      showDeleteConfirm: false,
      showDeleteAllConfirm: false,
      conversationToDelete: null,

      // File handling
      selectedFiles: [],
      isDragging: false,

      // Advanced options
      showAdvanced: false,
      enableKnowledgeBase: true,
      enableDeepAnalysis: false,
      showTokenUsage: false,
      magicPromptLength: 'medium',
      isMagicLoading: false,

      // App info
      appVersion: '1.3.5',

      // Snackbar
      snackbar: {
        open: false,
        message: '',
        vertical: 'top',
        horizontal: 'right',
      },

      // Sidebar
      setIsSidebarOpen: open => set({ isSidebarOpen: open }),
      toggleSidebar: () => set(state => ({ isSidebarOpen: !state.isSidebarOpen })),
      setActiveSection: section => set({ activeSection: section }),

      // Modals
      setIsSettingsModalOpen: open => set({ isSettingsModalOpen: open }),
      setIsFeedbackModalOpen: open => set({ isFeedbackModalOpen: open }),
      setIsUserMenuOpen: open => set({ isUserMenuOpen: open }),
      setShowDeleteConfirm: show => set({ showDeleteConfirm: show }),
      setShowDeleteAllConfirm: show => set({ showDeleteAllConfirm: show }),
      setConversationToDelete: conversation =>
        set({ conversationToDelete: conversation }),

      openDeleteConfirm: conversation =>
        set({ conversationToDelete: conversation, showDeleteConfirm: true }),

      closeDeleteConfirm: () =>
        set({ conversationToDelete: null, showDeleteConfirm: false }),

      openDeleteAllConfirm: () => set({ showDeleteAllConfirm: true }),

      closeDeleteAllConfirm: () => set({ showDeleteAllConfirm: false }),

      // Files
      setSelectedFiles: files => set({ selectedFiles: files }),

      addFiles: newFiles =>
        set(state => ({
          selectedFiles: [...state.selectedFiles, ...newFiles].slice(0, 5),
        })),

      removeFile: index =>
        set(state => ({
          selectedFiles: state.selectedFiles.filter((_, i) => i !== index),
        })),

      clearFiles: () => set({ selectedFiles: [] }),

      setIsDragging: dragging => set({ isDragging: dragging }),

      // Advanced options
      setShowAdvanced: show => set({ showAdvanced: show }),
      toggleShowAdvanced: () => set(state => ({ showAdvanced: !state.showAdvanced })),

      setEnableKnowledgeBase: enable => set({ enableKnowledgeBase: enable }),
      toggleKnowledgeBase: () =>
        set(state => ({ enableKnowledgeBase: !state.enableKnowledgeBase })),

      setEnableDeepAnalysis: enable => set({ enableDeepAnalysis: enable }),
      toggleDeepAnalysis: () =>
        set(state => ({ enableDeepAnalysis: !state.enableDeepAnalysis })),

      setShowTokenUsage: show => set({ showTokenUsage: show }),
      toggleTokenUsage: () => set(state => ({ showTokenUsage: !state.showTokenUsage })),

      setMagicPromptLength: length => set({ magicPromptLength: length }),
      setIsMagicLoading: loading => set({ isMagicLoading: loading }),

      // App info
      setAppVersion: version => set({ appVersion: version }),

      // Snackbar
      showSnackbar: (message, vertical = 'top', horizontal = 'right') =>
        set({
          snackbar: { open: true, message, vertical, horizontal },
        }),

      hideSnackbar: () =>
        set(state => ({
          snackbar: { ...state.snackbar, open: false },
        })),

      inputFocusSignal: 0,
      triggerInputFocus: () => set({ inputFocusSignal: Date.now() }),
      // Reset operations
      resetUIState: () =>
        set({
          isSidebarOpen: false,
          activeSection: null,
          selectedFiles: [],
          isDragging: false,
          showAdvanced: false,
        }),
    }),
    { name: 'UIStore' }
  )
)
